












import { Component, Mixins, Prop } from "vue-property-decorator";
import { DateInputMethodKinds } from "../../../../domain/document/inputMethodKinds";
import { DateInputMethodOptionKinds } from "../../../../domain/document/inputMethodOptionKinds";
import { ScreenKinds } from "../../../../domain/his/behavior/ScreenKinds";
import DateObject from "../../../document/editor/objects/DateObject.vue";
import InputMethodSelector from "./InputMethodSelector.vue";
import Enumerable from "linq";

@Component({
  components: {
    InputMethodSelector,
  }
})
export default class DateInputMethodSelector extends Mixins() {
  @Prop()
  source: DateObject;

  @Prop({ default: true })
  isUnselectionEnable: boolean;

  get optionSet(): DateInputMethodKinds[] {
    if (this.source.isEditDisabledByRuleSet) {
      return [];
    }
    const kinds = this.optionSets[this.source.inputMethodOptionKind];
    const options = Enumerable.from(kinds)
      .where(k => this.shouldFreeInput(k) && this.shouldCalendarInput(k) && this.shouldHisInfoSelectInput(k) && this.existsItems(k))
      .toArray();
    // フリー入力のみの場合は空にする
    return options.length === 1 && options[0] === DateInputMethodKinds.FreeInput
      ? []
      : options;
  }

  private shouldFreeInput(kind: DateInputMethodKinds): boolean {
    return this.source.isFreeInputable || kind !== DateInputMethodKinds.FreeInput;
  }

  private shouldCalendarInput(kind: DateInputMethodKinds): boolean {
    return this.source.isCalendarInputtable || kind !== DateInputMethodKinds.Calendar;
  }

  private shouldHisInfoSelectInput(kind: DateInputMethodKinds): boolean {
    return this.source.isHisInfoSelectInputable || kind !== DateInputMethodKinds.HisInfoSelect;
  }

  private existsItems(kind: DateInputMethodKinds): boolean {
    // ユーザ定義は起動時にキャッシュしておけば対応できるのでHIS情報のみ判定
    const hisItemParameter = this.source.editingSource.hisItemParameter;
    return kind !== DateInputMethodKinds.HisInfoSelect
      || hisItemParameter === null
      || hisItemParameter.screenKind !== ScreenKinds.List
      || this.source.commonComponents.editors.hisInformation.containsInformation(hisItemParameter.informationKind);
  }

  get unselection(): DateInputMethodKinds {
    return this.isUnselectionEnable
      ? this.unselectionSets[this.source.inputMethodOptionKind]
      : null;
  }

  displayTexts: { key: DateInputMethodKinds, text: string }[] = [
    { key: DateInputMethodKinds.None, text: "入力不可" },
    { key: DateInputMethodKinds.FreeInput, text: "フリー入力" },
    { key: DateInputMethodKinds.Calendar, text: "カレンダー入力" },
    { key: DateInputMethodKinds.Calculate, text: "計算入力" },
    { key: DateInputMethodKinds.HisInfoSelect, text: "データ選択" },
    { key: DateInputMethodKinds.UserDefinitionSelect, text: "データ選択" },
    // 平成直接入力等は徳大では使用しない
  ];

  private optionSets: { [key in DateInputMethodOptionKinds]: DateInputMethodKinds[] } = {
    Normal: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar ],
    Link: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar, DateInputMethodKinds.None ],
    Calculate: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar, DateInputMethodKinds.Calculate ],
    HisItem: [ DateInputMethodKinds.Calendar, DateInputMethodKinds.None ],
    HisFreeInput: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar, DateInputMethodKinds.None ],
    HisInfoSelect: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar, DateInputMethodKinds.HisInfoSelect ],
    UserDefinition: [ DateInputMethodKinds.FreeInput, DateInputMethodKinds.Calendar, DateInputMethodKinds.UserDefinitionSelect ],
  };

  private unselectionSets: { [key in DateInputMethodOptionKinds]: DateInputMethodKinds } = {
    Normal: null,
    Link: null,
    Calculate: null,
    HisItem: null,
    HisFreeInput: DateInputMethodKinds.None,
    HisInfoSelect: null,
    UserDefinition: null,
  };
}
